import { render, staticRenderFns } from "./CreateWalletInput.vue?vue&type=template&id=a84cb94c&scoped=true&"
import script from "./CreateWalletInput.vue?vue&type=script&lang=js&"
export * from "./CreateWalletInput.vue?vue&type=script&lang=js&"
import style0 from "./CreateWalletInput.vue?vue&type=style&index=0&id=a84cb94c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84cb94c",
  null
  
)

export default component.exports